<template>
	<NuxtLink
		:to="option.route"
		:target="option.openInNewTab ? '_blank' : undefined"
		:external="option.openInNewTab"
		class="size-full"
		@click="handleClick"
	>
		<PortalHeaderNavMobileOption :class="props.class" :option="option" />
	</NuxtLink>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { useEvents } from '~/composables/events/useEvents';
import { useNavigationStore } from '~/store/navigationStore';

import { type NavDefaultOptionConfig } from '.';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	option: NavDefaultOptionConfig;
}>();

const navigationStore = useNavigationStore();
const { trackCtaProfileClicked } = useEvents();
const route = useRoute();
const { t } = useI18n();

const handleClick = () => {
	// Track click for profile-related options
	if (props.option.route === '/perfil') {
		trackCtaProfileClicked({
			cta_text: 'Meus dados',
			current_page: route.fullPath,
			click_user_information: true
		});
	} else if (props.option.route === '/colecoes/minha-colecao') {
		trackCtaProfileClicked({
			cta_text: 'Minha coleção',
			current_page: route.fullPath,
			click_collection: true
		});
	}

	navigationStore.closeMenus();
};
</script>
